import type { TableColumnMeta } from '../common/ColumnSelector';

/** Column catalogue for the audit log. IP address and user agent are carried
 *  by every log entry but were never surfaced; they are available here. */
export const AUDIT_COLUMN_METADATA: TableColumnMeta[] = [
  { id: 'timestamp', label: 'Timestamp', category: 'Event' },
  { id: 'user_id', label: 'User', category: 'Event' },
  { id: 'action', label: 'Action', category: 'Event' },
  { id: 'resource_type', label: 'Resource Type', category: 'Resource' },
  { id: 'resource_id', label: 'Resource ID', category: 'Resource' },
  { id: 'ip_address', label: 'IP Address', category: 'Origin' },
  { id: 'user_agent', label: 'User Agent', category: 'Origin' },
  { id: 'details', label: 'Details', category: 'Resource' },
];

/** The six columns the log has always shown. The origin columns stay off until
 *  asked for - they are wide and only matter when tracing an actor. */
export const AUDIT_DEFAULT_COLUMNS = [
  'timestamp',
  'user_id',
  'action',
  'resource_type',
  'resource_id',
  'details',
];
